import { all, apply, put, takeLatest } from 'redux-saga/effects';

import { getSingleton } from '@occc-app/Activate/api';
import { Constraint as ConstraintAPI } from '@occc-app/Activate/apiTypes';
import { safeAsync } from '@occc-app/lib/safeAsync';

import actions from './actions';
import { deserializeConstraint, deserializeConstraintType } from './deserializers';

import { types as offerTypes, ActionCreators as OfferActionCreators } from '../../../redux';

// Request Constraints
function* requestConstraint(
  id: string,
  apiConstraintType: ConstraintAPI['attributes']['constraint_type'],
) {
  const core = getSingleton();
  try {
    const constraintType = deserializeConstraintType(apiConstraintType);
    yield put(actions.requestConstraint(id, constraintType));

    const constraintData = (yield apply(core, core.constraints.id(id).show, [{}])) as {
      data: ConstraintAPI;
    };

    const selectedConstraint = deserializeConstraint(constraintData.data);
    yield put(actions.requestConstraintOK(selectedConstraint));
  } catch (error) {
    const errorMessages = error.errorMessages || [
      {
        message: `Unable to request constraint: ${apiConstraintType}`,
      },
    ];
    yield put(actions.requestConstraintERR(errorMessages, error));
  }
}

function* requestConstraints(action: ReturnType<OfferActionCreators['RequestOfferOK']>) {
  yield all(
    action.constraints.map((constraint) =>
      requestConstraint(constraint.id!, constraint.attributes.constraint_type),
    ),
  );
  yield put(actions.requestConstraintsOK());
}

const sagas = {
  requestConstraints: safeAsync(requestConstraints),
};

export default function* saga() {
  yield takeLatest(offerTypes.REQUEST_OFFER_OK, sagas.requestConstraints);
}
